let baseUrl = '/api/jsonws'; //'/api/v1';
let lifeRayUrl = '/api/jsonws/invoke';
let options = {baseUrl, credentials: 'same-origin', mode: 'no-cors'};

/** Параметр, содержащий адрес сервера Liferay */
const liferay_server_url = "liferay.server.url";
/** Параметр, содержащий адрес сервиса получения параметров визуализации */
const liferay_portlet_views_rpc_url ="liferay.portlet.views.rpc.url";
/** Параметр, содержащий идентификатор элемента в DOM c настройками */
const id_settings = "settings";

/** 
 * В HTML странице должен быть элемент с id_settings в котором атрибут liferay_server_url содержит
 * адрес сервера Liferay, а liferay_portlet_views_rpc_url адрес сервсиа получения настройки визуализации активов
 *  например  <div class="display: none;" id="settings"
 *       liferay.server.url = "http://62.61.8.56:8080"
 *       liferay.portlet.views.rpc.url = "http://62.61.8.56:8080/web/guest/setupview?p_p_id=setupview_WAR_SetupViewportlet&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_cacheability=cacheLevelPage"
 *   </div>
 * 
 * Для режима разработчика проверить возвращается ли в helper.js правильный groupId и адрес сервиса 
 * в условии if (process.env.NODE_ENV === 'development')
 */
 const loadLiferaySettings = settings =>{
	const node = document.getElementById(id_settings);
	if (!node){
		alert("Параметры соединения c сервером коллективной работы отсутствуют!\nБудут использованы встроенные настройки!\nОбратитесь к администратору системы.")
		return;
	}
    if (node.getAttribute(liferay_server_url)==null){
		console.warn("Liferay server url not setting ("+liferay_server_url+" empty)!");
	} else {
        settings.baseUrl = node.getAttribute(liferay_server_url)+'/api/jsonws';
        settings.lifeRayUrl = node.getAttribute(liferay_server_url)+'/api/jsonws/invoke';
        settings.options.baseUrl = settings.baseUrl;
    }

    if (node.getAttribute(liferay_portlet_views_rpc_url)==null)
		console.warn("Url views rpc not setting ("+liferay_portlet_views_rpc_url+" empty)!");
	 else 
        settings.rpc_url = node.getAttribute(liferay_portlet_views_rpc_url);
    
    console.log("liferay settings", settings);
	return settings;
}


if (process.env.NODE_ENV === 'development') {
    //Режим разработки подключается к 62.61.8.56:8080 
    //(Liferay экспертной системы) //rtn-dev.imik.tech:8080
    //ЦСИ csi2.semanticpro.org
    //СУТ sut.semanticpro.org
    baseUrl = 'http://sut.semanticpro.org/api/jsonws';
    lifeRayUrl = 'http://sut.semanticpro.org/api/jsonws/invoke';
    options.credentials = 'include';
    options.mode='cors';
    options.baseUrl = baseUrl;
}

let settings = loadLiferaySettings({
    baseUrl,
    lifeRayUrl,
    loadTimeout: 300000,
    DATE_TIME_FORMAT: 'DD.MM.YYYY HH:mm',
    DATE_FORMAT: 'DD.MM.YYYY',
    defaultLocale: 'ru',
    // liferay_username: 'misha@e-projecting.ru',
    // liferay_password: '1Qaz2Wsx3Edc',
    //liferay_username: 'liferay@liferay.com',
    //liferay_password: 'test',
    //liferay_username: 'admin@semanticpro.org',
    //liferay_password: 'qfYXPSdnGqYje5',
    liferay_username: 'Mishael',
    liferay_password: '1Qaz2Wsx3Edc',
    options,
    defaultLimit: 10,
    rpc_url: "http://sut.semanticpro.org/web/tacho/setupview?p_p_id=setupview_WAR_SetupViewportlet&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_cacheability=cacheLevelPage"
//    rpc_url: "http://csi2.semanticpro.org/web/guest/setup-views?p_p_id=setupview_WAR_SetupViewportlet&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_cacheability=cacheLevelPage"
});

export default settings;
